<template>
    <div ref="container" >
        <vs-popup :active.sync="open" :title="$t('Deadline')">
            <flat-pickr :config="configDateTimePicker" v-model="data"/>
            <vs-divider/>

            <vs-button color="success" class="mt-6; mr-1" @click="saveDeadline">{{$t("Save")}}</vs-button>

        </vs-popup>

    </div>

</template>
<script>
    import Vue from "vue";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default Vue.extend({
        components: {
            flatPickr,
        },
        data () {
            return {
                data: null,
                open: false,
                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        methods: {
            getValue() {
                return this.data;
            },
            saveDeadline() {
                this.open = false;
                Vue.nextTick(() => {
                    this.params.api.stopEditing();
                });
            }
        },
        watch:{
            open: function () {
                if(!this.open){
                    Vue.nextTick(() => {
                        this.params.api.stopEditing();
                    });
                }
            }
        },
        created() {
            this.data = this.params.data.deadline
        },
        mounted() {
            Vue.nextTick(() => {
                this.open = true;

            });
        }
    });

</script>
